// FeederDataSourcesPill — tiny provenance badge above the employer
// feeder-courses table. See `lib/employerSources.js` for the shared
// source metadata used across the uni page too.
import { Database } from "lucide-react";
import { labelForTag } from "@/lib/employerSources";

export default function FeederDataSourcesPill({ sources }) {
  if (!Array.isArray(sources) || sources.length === 0) return null;
  return (
    <div
      data-testid="employer-feeder-sources"
      className="mb-3 flex flex-wrap items-center gap-2 text-[11px] text-stone-600"
    >
      <span className="inline-flex items-center gap-1 text-stone-500">
        <Database className="w-3 h-3" /> Data source{sources.length > 1 ? "s" : ""}:
      </span>
      {sources.map((s) => {
        const meta = labelForTag(s);
        return (
          <span
            key={s}
            data-testid={`employer-feeder-source-${s}`}
            title={meta.note}
            className="inline-flex items-center rounded-full border border-stone-200 bg-stone-50 px-2 py-0.5 text-stone-700"
          >
            {meta.label}
          </span>
        );
      })}
    </div>
  );
}
